import { BottomSheet, Flex, Tag } from 'components/InterUI/InterUI'
import { Separator } from 'components'
import { ITicket } from 'store/afterSales/types'
import useBoundState from 'store'

import { Text } from '@interco/inter-ui/components/Text'
import { formatToBrazilianDate } from '@interco/lib-util'

import * as S from './Redemption.styles'

interface Props {
  tickets: ITicket[]
  handleCloseBottomSheet: () => void
}

const TicketToRedeem = ({ ticket }: { ticket: ITicket }) => (
  <Flex direction="column" gap="4px">
    <Text variant="body-3" bold colorWeight={600}>
      Nº {ticket.luckyNumber}
    </Text>
    <Text variant="body-3" colorWeight={400}>
      Resgate automático em {formatToBrazilianDate(new Date(ticket.redemptionDate ?? ''))}
    </Text>
    <Separator borderWidth="1px" type="solid" margin="16px 0" />
  </Flex>
)

export const RedemptionTicketsBS = ({ handleCloseBottomSheet, tickets }: Props) => {
  const contentTitle = useBoundState((state) => state.contentTitle)

  const totalTickets = tickets.length
  return (
    <BottomSheet onClose={handleCloseBottomSheet} noSwipe={tickets.length > 5}>
      <S.RedemptionTicketsWrapper>
        <Text variant="body-2" color="primary" bold colorWeight={600}>
          {contentTitle.value2} com resgate disponível
        </Text>
        <Tag size="small" color="var(--primary500)">
          <Text variant="caption-2" color="primary" bold colorWeight={600}>
            {totalTickets > 1
              ? `${totalTickets} ${contentTitle.value2Lowercase}`
              : `${totalTickets} ${contentTitle.value1Lowercase}`}
          </Text>
        </Tag>
        {tickets.map((ticket) => (
          <TicketToRedeem key={ticket.ticketId} ticket={ticket} />
        ))}
      </S.RedemptionTicketsWrapper>
    </BottomSheet>
  )
}
